var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCelebration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.998 44.084a.5.5 0 0 1-.704-.592L21 18s6.058 3.543 9 6c2.417 2.018 6.259 6.116 7.556 7.517a.495.495 0 0 1-.145.78L13.998 44.084z",
    fill: "#F79A64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m41.004 15.18 1.743.599s1.194 3.149-2.244 6.075c-1.517 1.292-6.872-1.265-10.411.531-1.808.918-3.987 5.477-3.987 5.477l1.743.599s1.902-4.378 3.987-5.477c2.888-1.522 5.593-.596 6.925-1.729 3.438-2.926 2.244-6.075 2.244-6.075z",
    fill: "#F9B690",
    stroke: "#F9B690",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.203 27.927 26.585 28s-3.375-2.127-3.584-5.536c-.092-1.504 5.072.224 5.864-2.318.195-.622-1.099-1.916-1.861-3.577-.088-.192 2.305-1.318 1.981-1.71-2.134-2.58-4.422-2.736-4.422-2.736l.15-2.123s4.947 3.318 5.263 4.004c.35.759-3.22 2.678-3.963 3.42-.726.724 1.67 1.754 1.571 2.1-.6 2.118-3.045 1.548-2.965 2.868.209 3.408 3.584 5.535 3.584 5.535z",
    fill: "#F9B690",
    stroke: "#F9B690"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m40.863 36 2.137.863L42.137 39 40 38.137 40.863 36zM31.863 4 34 4.863 33.137 7 31 6.137 31.863 4zM48.425 31 50 32.819 47.575 34 46 32.181 48.425 31zM46.425 21 48 22.819 45.575 24 44 22.181 46.425 21zM35.819 13 37 15.425 35.181 17 34 14.575 35.819 13zM19 12.668 18.331 15 16 14.332 16.669 12l2.331.668z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m43.727 26.689-.758 2.518s-4.357-.697-7.219-.137c-2.862.56-6.871 2.897-6.871 2.897l.758-2.518s4.698-2.355 7.27-2.859c2.571-.504 6.82.099 6.82.099z",
    fill: "#F9B690",
    stroke: "#F9B690",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.386 45.03a.5.5 0 0 1-.71-.577l7.282-26.576a.504.504 0 0 1 .873-.19c1.577 1.905 5.809 6.92 8.204 8.85 2.3 1.854 6.893 4.076 8.88 4.998.38.177.392.72.017.912L13.386 45.03z",
    fill: "#F58341"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "apopadbqfa",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 17,
    width: 27,
    height: 29
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.386 45.03a.5.5 0 0 1-.71-.577l7.282-26.576a.504.504 0 0 1 .873-.19c1.577 1.905 5.809 6.92 8.204 8.85 2.3 1.854 6.893 4.076 8.88 4.998.38.177.392.72.017.912L13.386 45.03z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#apopadbqfa)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.538 35.627s2.742 3.615 4.354 4.869c1.613 1.254 5.101 2.483 5.101 2.483l-1.378 1.755s-3.494-1.41-5.162-2.706c-1.668-1.297-4.293-4.646-4.293-4.646l1.378-1.755zM13.954 27.991s4.39 5.392 6.883 7.33c2.492 1.938 7.73 4.033 7.73 4.033l-1.838 2.34s-5.264-2.35-7.842-4.355c-2.578-2.005-6.77-7.007-6.77-7.007l1.836-2.34zM18.547 19.674s5.558 6.49 8.637 8.884c3.079 2.393 9.415 5.151 9.415 5.151l-2.015 2.567s-6.386-3.054-9.57-5.53c-3.185-2.476-8.482-8.506-8.482-8.506l2.015-2.566z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebration);
export default __webpack_public_path__ + "static/media/celebration.440917aec020e9df75e232c64705f60c.svg";
export { ForwardRef as ReactComponent };